<template>
  <div class="page-block left-zone">
    <div ref="textBlock" v-html="content.text" :lang="route.params.lang"></div>
    <!-- <div class="zoom-button" @click="toggleZoom"><FontAwesomeIcon icon="chevron-up" size="sm"/></div> -->
  </div>
  <div class="page-block right-zone">
    <GalleryBlock :items="content.gallery_ids"/>
  </div>
</template>

<style>
.left-zone{
  position:relative;
}
.zoom-button {
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 32px;
  display: block;
  font-size: 2rem;
  transition: 500ms;
}
#app.zoomed .zoom-button{
  rotate: 180deg;
}
@media only screen and (min-width: 1024px) {
  .zoom-button {
    display: none;
  }
}
</style>

<script setup>
import { reactive, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { usePage } from '@/stores/page_state'
import GalleryBlock from '@/components/GalleryBlock.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'


library.add(faChevronUp)

const axios = require('axios');

const VUE_APP_API_BASE_URL=process.env.VUE_APP_API_BASE_URL // "http://dev.la-sira.fr/wp-json/wp/v2"
const VUE_APP_MAIN_MENU_FR_ID=process.env.VUE_APP_MAIN_MENU_FR_ID
const VUE_APP_MAIN_MENU_EN_ID=process.env.VUE_APP_MAIN_MENU_EN_ID
  
const pageStore = usePage()

const route = useRoute()
const router = useRouter()

var decodeEntities = (function() {
  // this prevents any overhead from creating the object each time
  var element = document.createElement('div');

  function decodeHTMLEntities (str) {
    if(str && typeof str === 'string') {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }

    return str;
  }

  return decodeHTMLEntities;
})();

function getPage(id) {
  content.gallery_ids = []
  pageStore.mediaCollection = []
  axios.get(VUE_APP_API_BASE_URL + '/main_page/' + String(id) + 
    '?_embed&lang=' + route.params.lang )
  .then(
    (response) =>{
      let page = response.data
      content.text = '<h1>' + page.title.rendered + '</h1>' + page.content.rendered
      content.gallery_ids = page.acf.post_images
      pageStore.currentPage = {slug: page.slug, lang: page.lang, translations: page.translations}
      pageStore.mediaCollection = page["_embedded"]["acf:attachment"].reverse()
      //document.title = `${page.title.rendered} - SIRA`
      document.title = decodeEntities(page.title.rendered) + ' - SIRA'
    }
  )
}

const content = reactive({text: "", gallery_ids: []})

function mapPageId(name){
  return new Promise(resolve => {
    switch(name){     
      case "studio":
      resolve(route.params.lang=='fr'?47:(route.params.lang=='en'?198:47))
      break
    case "legal":
      resolve(route.params.lang=='fr'?194:(route.params.lang=='en'?197:194))
      break
    case "privacy":
      resolve(route.params.lang=='fr'?195:(route.params.lang=='en'?196:195))
      break
    case "contacts":
      resolve(route.params.lang=='fr'?182:(route.params.lang=='en'?184:182))
      break
    case "studio_detail":
    case "consulting_detail":
    case "home_detail":
      axios.get(VUE_APP_API_BASE_URL + '/main_page?slug=' + route.params.id + '&lang=' + route.params.lang)
        .then(response =>{
          if(response.data && response.data.length > 0){
            resolve(response.data[0].id)
          } else {
            resolve(null)
            // resolve(route.params.lang=='fr'?181:(route.params.lang=='en'?VUE_APP_MAIN_MENU_EN_ID:VUE_APP_MAIN_MENU_FR_ID))
          }
        })
      break
    case "home":
    default:
      resolve(route.params.lang=='fr'?181:(route.params.lang=='en'?VUE_APP_MAIN_MENU_EN_ID:VUE_APP_MAIN_MENU_FR_ID))
      break
    }
    return(null)
  })
}


mapPageId(route.name).then(id => {if(id!=null){
  getPage(id)
} else {
  router.push({name:'home',params:{lang:route.params.lang}})
}})

watch( () => route.path, () => { 
  mapPageId(route.name).then(id => {if(id!=null){
      getPage(id)
    } else {
      router.push({name:'home',params:{lang:route.params.lang}})
    }})
} )
</script>